module.exports = __webpack_public_path__ + "fonts/InterBold.cef517a1.TTF";